'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import type { FunnelSchema } from '~/lib/schemas/funnel-schema'
import { funnelSchema } from '~/lib/schemas/funnel-schema'
import { useFunnelStore } from '../../_hooks/use-funnel-store'
import type { FunnelStepComponent } from '../../types'
import { FunnelStep } from '../FunnelStep'

const schema = funnelSchema.pick({ investments: true }).required()

export const Investment: FunnelStepComponent = ({ onSubmit }) => {
  const { data, calculateInvestableAssetsRange } = useFunnelStore.getState()
  const { control, formState, handleSubmit } = useForm({
    resolver: zodResolver(schema),
    defaultValues: { investments: data.investments },
    mode: 'onChange',
  })

  const beforeSubmit = (data: Partial<FunnelSchema>) => {
    calculateInvestableAssetsRange(data)
    onSubmit(data)
  }

  return (
    <FunnelStep onSubmit={handleSubmit(beforeSubmit)}>
      <div className="flex flex-col gap-1">
        <FunnelStep.Title>Estimate your household&rsquo;s investable assets.</FunnelStep.Title>
        <FunnelStep.Subtitle>
          This does NOT include your 401k or 403b. This includes bonds, mutual funds, ETFs and other assets held in a
          brokerage account, IRA, Roth IRA or other investment account not connected to an employer.
        </FunnelStep.Subtitle>
      </div>
      <FunnelStep.CurrencyInput name="investments" placeholder="$ Investable Assets" control={control} autoFocus />
      <FunnelStep.Button disabled={!formState.isValid}>Next</FunnelStep.Button>
    </FunnelStep>
  )
}

Investment.path = 'investments'
Investment.schema = schema
Investment.formActionFields = ['investments']
